import React, { useState, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Input, Row, Col, Form, Tooltip } from 'antd';
import {
    theme,
    CardAnt,
    ButtonAnt,
    InputComponent,
    SelectComponent,
    Text
} from '@pfmam/pfmam';
import { Container, Box } from '../../styles/globalStyle';
import { CaretDownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import BeneficiaryAddressFields from './beneficiaryAddressFields';
const { TextArea } = Input;

const ButtonWrapper = styled.div`
  .anticon-check-circle {
    margin-left: 30px;
    margin-top: 2px;
  }
`;
const OverrideStyle = createGlobalStyle`
  .ant-form-item-control-input-content {
    & > span {
      width: 100%;
    }
    .primary.ant-select-single:not(.ant-select-customize-input) {
      .ant-select-selector {
        height: 52px;
        width: 100%;
        background: ${theme.colors.white};
        color: ${theme.colors.black_secondary};
        border: 1px solid ${theme.colors.grey};
        padding: 14px 20px;
        .ant-select-selection-item,
        .ant-select-selection-placeholder {
          line-height: 20px;
        }
        .ant-select-selection-search-input {
          height: 100%;
        }
      }
      .ant-select-arrow .anticon:not(.ant-select-suffix) {
        pointer-events: none;
    }
      .ant-select-arrow {
        font-size: ${theme.font_size.size_l};
        margin-top: 0;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
      }
      &.ant-select-focused {
        .ant-select-selector {
          box-shadow: ${theme.shadows.input_focus};
          border-color: ${theme.colors.blue_primay};
        }
          .ant-select-arrow {
          color: ${theme.colors.black_secondary};
        }
      } 
    }
  }

  
  .form-select-dropdown {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
      .ant-select-item {
        &.ant-select-item-group {
          color: ${theme.colors.grey_tertiary};
          min-height: 16px;
          line-height: 16px;
          padding: 6px 12px;
          &:hover {
            background: none;
          }
        }
      }
      .ant-select-item-option-selected,
      .ant-select-item-option-active {
        &:not(.ant-select-item-option-disabled) {
          background: ${theme.colors.white};
          font-weight: normal;
        }
      }
      .ant-select-item {
        min-height: 40px;
        line-height: 24px;
        padding: 8px 12px;
        font-size: ${theme.font_size.size_xl};
        color: ${theme.colors.black_secondary};
        font-family: 'Inter';
        &:hover {
        background: ${theme.colors.light_grey};
        font-family: 'Inter';
      }
    }
  }
`;

const Wrapper = styled.div`
  padding-top: 32px;
`;

const OverrideButtonAnt = styled(ButtonAnt)`
  &&& {
    background: ${(props) => props.linkTextColor};
    color: white;
    font-weight:bold;
  }
`;

const OverrideButtonAntPermissions = styled(ButtonAnt)`
  &&& {
    background: #e0b31f;
    color: black;
    font-weight:bold;
  }
`;

const CreateWireInstructionsComponent = (props) => {
    const { form, onSubmit, bankName, bankCity, bankState, abaNumber, setPermissionsModalVisible, canSubmitInstruction, setIsTouched, submitted, states } = props;
    const primary_color = useSelector((state) => state.siteInfo.primaryColor);

    useEffect(() => {
        form.setFieldsValue({
            BankName: bankName.slice(0, 40).trim(),
            BankCity: bankCity.slice(0, 25),
            BankState: bankState,
            ABANumber: abaNumber.slice(0, 9)
        });
    }, []);

    const handleBlur = (e) => {
        const value = e.target.value;
        const name = e.target.getAttribute('data-name');
        const trimmedValue = value.replace(/\n/g, "\r\n");
        form.setFieldsValue({ [name]: trimmedValue });
    }

    const handleBankNameBlur = (e) => {
        const value = e.target.value;
        const name = e.target.getAttribute('data-name');
        const trimmedValue = value.trim();
        form.setFieldsValue({ [name]: trimmedValue });
    }

    return (
        <Wrapper>
            <OverrideStyle />
            <Container>
                <CardAnt
                    cardContent={
                        <Form
                            form={form}
                            onFieldsChange={() => {
                                setIsTouched(true);
                            }}
                            name="basic"
                            layout="vertical"
                            onFinish={onSubmit}
                            requiredMark={true}
                            className="forms"
                        >

                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="Bank Name" name="BankName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Bank Name Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={40}
                                            data-name="BankName"
                                            placeholder="Enter Bank Name"
                                            onBlur={handleBankNameBlur}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Account Number" name="BankAccountNumber"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Account Number Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={20}
                                            placeholder="Enter Linked Account Number"
                                            data-name="BankAccountNumber"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="City" name="BankCity"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'City Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={25}
                                            data-name="BankCity"
                                            placeholder="Enter Bank City"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Legal Account Owner" name="BeneName"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Legal Account Owner Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            maxLength={255}
                                            placeholder="Enter Legal Account Owner"
                                            data-name="BeneName"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="State" name="BankState"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'State Required',
                                            },
                                        ]}
                                    >
                                        {/* <InputComponent
                                            type="default"
                                            maxLength={2}
                                            data-name="BankState"
                                        /> */}
                                        <SelectComponent
                                            option={states}
                                            placeholder="Enter Bank State"
                                            suffixIcon={<CaretDownOutlined />}
                                            dropdownClassName="form-select-dropdown"
                                            bordered={true}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Further Credit Account Number" name="BeneAccountNumber">
                                        <InputComponent
                                            type="default"
                                            maxLength={20}
                                            placeholder="Enter Further Credit Account Number, if applicable"
                                            data-name="BeneAccountNumber"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Row gutter={40}>
                                <Col span={12}>
                                    <Form.Item label="ABA" name="ABANumber"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'ABA Required',
                                            },
                                        ]}
                                    >
                                        <InputComponent
                                            type="default"
                                            disabled={true}
                                            maxLength={9}
                                            data-name="ABANumber"
                                        />
                                    </Form.Item>
                                </Col>

                                <Col span={12}>
                                    <Form.Item label="Further Credit To" name="BeneDetails">
                                        {/* <InputComponent
                                            type="default"
                                            maxLength={150}
                                            placeholder="Enter Further Credit Recipient, if applicable"
                                            data-name="BeneDetails"
                                        /> */}
                                        <TextArea
                                            maxLength={150}
                                            placeholder="Enter Further Credit Recipient, if applicable"
                                            autoSize
                                            data-name="BeneDetails"
                                            onBlur={handleBlur}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={40}>
                                <Col span={12}></Col>
                                <Col span={12}>
                                    <Form.Item label={
                                        <span>
                                            Nickname&nbsp;
                                            <Tooltip title="Viewable by all team members with access to this account.">
                                                <InfoCircleOutlined style={{ fontSize: '14px' }} />
                                            </Tooltip>
                                        </span>

                                    } name="NickName">
                                        <InputComponent
                                            type="default"
                                            maxLength={50}
                                            placeholder="Enter Nickname to help identify instruction"
                                            data-name="BeneDetails"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Row>
                                <Col span={24}>
                                    {/* <Box display="flex" justifycontent="flex-end">
                                        <span style={{ color: "red" }}>*</span>
                                    </Box> */}
                                    <Box display="flex" justifycontent="flex-end">
                                        <OverrideButtonAntPermissions label="Link Account(s)" type="Secondary" onClick={() => setPermissionsModalVisible(true)} />
                                    </Box>
                                </Col>
                            </Row>

                            <BeneficiaryAddressFields states={states} />

                            <Row>
                                <Col span={24}>
                                    <Form.Item name="WireInstructionID" hidden initialValue="10">
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                    <Form.Item name="ParentID" hidden initialValue="0">
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                    <Form.Item name="Status" hidden initialValue="0">
                                        <InputComponent type="hidden" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <br></br>
                            <p style={{ fontStyle: "italic", fontSize: "15px", lineHeight: "20px", whiteSpace: "normal" }}>By submitting, PFM Asset Management is permitted, per your direction, to move money from PFM Asset Management to the institution designated above.</p>
                            <Box display="flex" justifycontent="center">
                                <>
                                    <OverrideButtonAnt
                                        label="Submit"
                                        type="primary"
                                        htmlType="submit"
                                        linkTextColor={primary_color}
                                        disabled={canSubmitInstruction == false ? true : false}
                                        loading={submitted}
                                    />

                                </>
                            </Box>

                        </Form>
                    }
                    className="profile-card basic-card"
                    //title="New Wire Account Information"
                    title=
                    {<p>
                        <div>
                            <span>New Wire Account Information</span>
                            <br />
                            <p style={{ fontStyle: "italic", fontSize: "14px", lineHeight: "20px", whiteSpace: "normal" }}>Wire transfers are same-day electronic transfers of funds. New Linked Wire Accounts may take PFM Asset Management up to 48 hours to verify.</p>
                        </div>
                    </p>
                    }
                />

            </Container>
        </Wrapper>
    );
};

export default CreateWireInstructionsComponent;